<div class="keypad-buttons" [ngClass]="{ isActive: isActive() }">
  @for (button of buttons; track button) {
    <keypad-button
      [ngClass]="{ blank: button.value === '', disabled: button.disabled }"
      [keyPadButton]="button"
      class="keypad-button"
      (clicked)="onKeypadButton($event)"
    >
    </keypad-button>
  }
</div>
